module.exports = __webpack_public_path__ + "static/media/payment.43ee2f4d.svg";